import script from "./gamePrize.vue?vue&type=script&setup=true&lang=js"
export * from "./gamePrize.vue?vue&type=script&setup=true&lang=js"

import "./gamePrize.vue?vue&type=style&index=0&id=5f7e6e78&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f7e6e78"]])

export default __exports__